module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = " <%\nif(document.createStyleSheet && font_import !== '') {\n  document.createStyleSheet(font_import);\n} else {\n%> @import url(<%= font_import %>); <%\n}\n%> <%= namespace %> { overflow: hidden; -webkit-overflow-scrolling: touch; } <%= namespace %>, <%= namespaceModal %> { <%= (font_family !== '')? 'font-family:  '+font_family+';' : ''  %> <%= default_text_color.length>0? 'color: '+default_text_color : '' %>; } <%= namespace %> { <%= background.image.length>0? 'background-image: url('+background.image+');' : '' %> <%= background.position.length>0? 'background-position: '+background.position+';' : '' %> <%= background.repeat.length>0? 'background-repeat: '+background.repeat+';' : '' %> <%= background.color.length>0? 'background-color: '+background.color+';' : '' %> <%= background.size.length>0? 'background-size: '+background.size+';' : '' %> } <%= namespace %> h1, <%= namespace %> h2, <%= namespace %> h3, <%= namespace %> h4, <%= namespace %> h5, <%= namespace %> h6, <%= namespaceModal %> h1, <%= namespaceModal %> h2, <%= namespaceModal %> h3, <%= namespaceModal %> h4, <%= namespaceModal %> h5, <%= namespaceModal %> h6 { <%= default_headline_color.length>0? 'color: '+default_headline_color : '' %>; } <%= namespaceModal %>.modal .view-modal .modal-window { <%= modal_overlay_color.length>0? 'background: '+modal_overlay_color+';' : '' %> } @media (max-width: 749px) { <%= namespaceModal %>.modal .view-modal .modal-window { <%= modal_background_color.length>0? 'background: '+modal_background_color+';' : '' %> } } <%= namespaceModal %>.modal .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { <%= modal_background_color.length>0? 'background: '+modal_background_color+';' : '' %> } <%= namespace %> button, <%= namespace %> button.btn, <%= namespace %> button:hover, <%= namespace %> button.btn:hover { <%= buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' %> <%= buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' %> <%= buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' %> <%= buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' %> <%= buttons.background.length>0? 'background: '+buttons.background+';' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' %> } <%= namespace %> .top { <%= header_display.length>0 && header_display===\"false\"? 'display: none;' : '' %> } <%= namespace %> ul { <%= navigation_display.length>0 && navigation_display===\"false\"? 'display: none;' : '' %> } "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append(" ")
    ; 
if(document.createStyleSheet && font_import !== '') {
  document.createStyleSheet(font_import);
} else {

    ; __line = 5
    ; __append(" @import url(")
    ; __append(escapeFn( font_import ))
    ; __append("); ")
    ; 
}

    ; __line = 7
    ; __append(" ")
    ; __append(escapeFn( namespace ))
    ; __append(" { overflow: hidden; -webkit-overflow-scrolling: touch; } ")
    ; __append(escapeFn( namespace ))
    ; __append(", ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" { ")
    ; __append(escapeFn( (font_family !== '')? 'font-family:  '+font_family+';' : ''  ))
    ; __append(" ")
    ; __append(escapeFn( default_text_color.length>0? 'color: '+default_text_color : '' ))
    ; __append("; } ")
    ; __append(escapeFn( namespace ))
    ; __append(" { ")
    ; __append(escapeFn( background.image.length>0? 'background-image: url('+background.image+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( background.position.length>0? 'background-position: '+background.position+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( background.repeat.length>0? 'background-repeat: '+background.repeat+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( background.color.length>0? 'background-color: '+background.color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( background.size.length>0? 'background-size: '+background.size+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" h1, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h2, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h3, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h4, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h5, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h6, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h1, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h2, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h3, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h4, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h5, ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(" h6 { ")
    ; __append(escapeFn( default_headline_color.length>0? 'color: '+default_headline_color : '' ))
    ; __append("; } ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(".modal .view-modal .modal-window { ")
    ; __append(escapeFn( modal_overlay_color.length>0? 'background: '+modal_overlay_color+';' : '' ))
    ; __append(" } @media (max-width: 749px) { ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(".modal .view-modal .modal-window { ")
    ; __append(escapeFn( modal_background_color.length>0? 'background: '+modal_background_color+';' : '' ))
    ; __append(" } } ")
    ; __append(escapeFn( namespaceModal ))
    ; __append(".modal .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { ")
    ; __append(escapeFn( modal_background_color.length>0? 'background: '+modal_background_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" button, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button.btn, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button:hover, ")
    ; __append(escapeFn( namespace ))
    ; __append(" button.btn:hover { ")
    ; __append(escapeFn( buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.background.length>0? 'background: '+buttons.background+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .top { ")
    ; __append(escapeFn( header_display.length>0 && header_display==="false"? 'display: none;' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" ul { ")
    ; __append(escapeFn( navigation_display.length>0 && navigation_display==="false"? 'display: none;' : '' ))
    ; __append(" } ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}